var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestNum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 41.133,
    height: 40.025,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1354.8 1318.33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 754.67,
    y1: 1528.89,
    x2: 527.93,
    y2: 340.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#f6b55c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e2884c"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 1194.51,
    y1: 1445.13,
    x2: 972.64,
    y2: 256.87
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 881.86,
    y1: 1503.78,
    x2: 655.22,
    y2: 316.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 647.56,
    y1: 1391.14,
    x2: 720.14,
    y2: -387.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 880.62,
    y1: 1504.43,
    x2: 653.92,
    y2: 316.54
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 653.53,
    y1: 486.19,
    x2: 762.39,
    y2: 1221.08
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 716.77,
    y1: 1525.8,
    x2: 490.04,
    y2: 369.53
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 795.62,
    y1: 1486.86,
    x2: 568.89,
    y2: 360.34
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 927.49,
    y1: 1487.27,
    x2: 700.79,
    y2: 306
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1354.8 659.3c0 70.52-11.28 138.21-32.49 201.98-38.4 116.81-109.56 219.26-202.75 297.1-42.15 35.54-88.86 66.1-139.35 90.45-91.04 44.64-193.92 69.49-302.68 69.49-209.18 0-396.36-92.25-520.41-237.29C99.63 1014.14 55.6 936.01 29.01 850.29 10.21 789.94 0 725.64 0 659.29c0-23.81 1.34-47.07 3.77-70.05 4.01-36.31 11-71.88 20.68-106.36 5.61-20.12 12.34-39.7 20.14-58.8 15.86-41.01 35.96-80.22 60.14-116.81 40.01-62.22 91.03-117.34 149.85-163.08 16.67-13.06 34.11-25.59 52.36-36.81C413.28 39.41 540.6-.02 677.53-.02c189.07 0 360.11 75.49 482.85 197.25 30.35 29.81 57.74 62.46 81.38 97.5 3.76 4.94 6.97 9.92 10.2 15.15 20.14 31.08 37.33 63.76 51.82 98 23.89 55.93 39.75 115.76 46.75 178.22 2.91 24.06 4.28 48.34 4.28 73.19z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.82 579.8c0 6.85 0 13.39-.6 19.96-.83 31.62-4.22 62.41-10.22 92.35-4.54 22.51-10.26 44.18-17.1 65.58-1.43 4.82-3.1 9.39-4.86 14.24-4.53 13.37-9.95 26.48-15.36 39.6-10.53 24.23-22.76 47.33-36.15 69.84-10.86 17.39-22.52 34.51-35.04 50.74-19.37 25.1-40.45 48.44-63.49 69.8-5.96 6.04-12.27 11.42-18.54 16.82-27.6 24.26-57.8 45.62-89.98 63.86-9.39 5.73-19.08 10.86-29.06 15.67-46.4 23.38-96.52 40.76-148.94 50.47a562.587 562.587 0 0 1-109.91 10.84c-94 0-182.55-22.54-260.89-62.14-40.98-20.55-78.89-45.9-113.31-75.24-25.64-21.71-49.27-45.61-70.92-71.27-22.78-27.36-43-56.74-60.09-87.8-13.93-24.21-25.91-49.31-35.88-75.51-5.13-13.13-9.71-26.22-13.68-39.65-3.11-10.79-6.25-21.92-8.84-33.03-5.1-21.1-9.11-42.74-11.38-65.01-3.14-22.79-4.57-46.45-4.57-70.11 0-20.8 1.16-41.32 3.45-61.56 3.39-31.93 9.36-63.3 17.63-93.49 2.27-8.56 4.86-17.1 7.68-25.37 2.86-9.11 5.98-17.95 9.42-26.5 4.29-11.4 9.11-22.53 14.24-33.64 7.41-17.09 16.2-33.6 25.62-49.87 3.7-6.56 7.68-12.83 11.69-19.08 13.37-21.39 27.9-41.64 43.83-60.73 25.07-30.5 53.54-58.15 84.29-82.65 12.54-10.26 25.62-19.96 39.62-29.09 1.67-1.12 3.39-2.27 5.13-3.39 21.92-14.55 44.68-27.37 68.62-38.53C494.41 20.03 578.7.09 667.56.09c84.56 0 164.88 18.2 237.51 51 23.9 10.54 46.98 23.07 69.18 37.06 38.74 24.21 74.34 53.01 106.24 85.5l.56.56c13.97 13.97 27.05 28.79 39.59 44.49 10.26 12.81 20.23 26.49 29.34 40.46 3.11 4.56 5.98 8.83 8.84 13.39a570.95 570.95 0 0 1 44.14 86.1c4.82 11.65 9.36 23.65 13.35 35.88 7.43 21.95 13.71 44.49 18.25 67.29 3.7 17.66 6.52 35.63 8.55 53.6.56 5.13 1.15 9.95 1.43 15.08 1.67 16.26 2.27 32.8 2.27 49.31z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.86 98.41c-152.37.56-305.01.29-457.36-.59 1.67-1.12 3.39-2.27 5.13-3.39 21.92-14.55 44.68-27.37 68.62-38.53 109.62-1.68 219.53-2.8 329.2-3.7 52.11-.54 104.53-.85 156.64-1.12 23.9 10.54 46.98 23.07 69.18 37.06-60.94 3.42-121.87 9.97-171.41 10.26z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.48 1082.59c-9.39 5.73-19.08 10.86-29.06 15.67-46.4 23.38-96.52 40.76-148.94 50.47-123.87-13.41-248.03-42.76-370.8-51.3-40.98-20.55-78.89-45.9-113.31-75.24 86.26-4.88 173.97 3.97 263.69 17.93 109.67 17.14 219.57 42.48 330.64 42.48 9.95 0 37.31.6 67.77 0z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.03 878.79c41.29 9.42 139.26 21.39 210.46 53.32-19.37 25.1-40.45 48.44-63.49 69.8-27.05-27.91-91.16-35.32-115.06-41.32-218.71-54.72-444-75.53-667.83-96.35-23.64-2.28-68.93-.25-118.74-1.12-13.93-24.21-25.91-49.31-35.88-75.51 45.54 3.7 103.66.55 128.15 2.83 221.83 19.96 444.81 39.05 662.39 88.36z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.32 238.36C694.9 261.74 429.2 256.6 166.07 289.38c3.7-6.56 7.68-12.83 11.69-19.08 13.37-21.39 27.9-41.64 43.83-60.73 55.29-2.02 106.81-1.43 142.96-3.46 215.56-11.93 432.89-3.37 647.61-23.63 22.77-2.27 45.87-4.56 68.9-8.27 13.97 13.97 27.05 28.79 39.59 44.49-58.4 11.98-118.75 15.67-162.33 19.66z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.75 818.1c27.05-.32 46.98-2.86 60.94-6.57-10.53 24.23-22.76 47.33-36.15 69.84-9.11.56-17.66.87-24.79.87-112.49 1.12-227.28-33.39-337.75-47.88-80.03-10.3-158.35-21.4-236.08-43.06-116.78-32.49-232.11-82.65-355.41-83.23-13.11 0-64.09-.57-104.53 6.86-5.1-21.1-9.11-42.74-11.38-65.01 26.47-5.69 51.24-8.83 69.18-10.26 177.73-13.68 340.61 74.37 510.35 110.31 90.84 19.1 185.11 26.22 276.53 41.64 62.64 10.26 125.3 27.33 189.1 26.49z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63 400.25c-4.29-.29-8.55-.6-12.85-.87 2.86-9.11 5.98-17.95 9.42-26.5 4.29-11.4 9.11-22.53 14.24-33.64 58.92 8.55 127.85 4.01 183.67 7.72 129.87 8.83 259.73 16.82 389.57 23.9 167.46 9.42 334.92 17.1 502.63 23.67 7.43 21.95 13.71 44.49 18.25 67.29-210.75-8.24-421.45-18.25-632.23-30.5-157.75-9.11-315.24-19.66-472.72-31.06z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.65 606.57c-97.1 13.13-197.06 13.43-295.87 14 88.27 65.84 221.25 52.14 325.23 71.53-4.54 22.51-10.26 44.18-17.1 65.58-1.43 4.82-3.1 9.39-4.86 14.24-15.08-12.82-43.55-24.81-74.03-28.79-125.88-16.82-251.47-27.67-330.06-137.67-14.81-21.09 5.43-47.29 27.64-48.45 105.64-4.57 212.17-3.45 317.26-12.27 31.03-2.55 60.63-7.39 89.71-14.24 1.67 16.26 2.27 32.8 2.27 49.31 0 6.85 0 13.39-.6 19.96-13.08 2.84-26.2 5.14-39.57 6.81z",
    style: {
      fill: "url(#i)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestNum);
export default __webpack_public_path__ + "static/media/quest_num.9e5779ff6bc115ab1902f4feba991ff5.svg";
export { ForwardRef as ReactComponent };